import { render, staticRenderFns } from "./NodeConfig.vue?vue&type=template&id=a094bc6e&scoped=true"
import script from "./NodeConfig.vue?vue&type=script&lang=js"
export * from "./NodeConfig.vue?vue&type=script&lang=js"
import style0 from "./NodeConfig.vue?vue&type=style&index=0&id=a094bc6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a094bc6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a094bc6e')) {
      api.createRecord('a094bc6e', component.options)
    } else {
      api.reload('a094bc6e', component.options)
    }
    module.hot.accept("./NodeConfig.vue?vue&type=template&id=a094bc6e&scoped=true", function () {
      api.rerender('a094bc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/config/NodeConfig.vue"
export default component.exports